import initSiteNav from "./siteNav.js"

export default function initSite() {
  initSiteNav()
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add("is-visible")
          observer.unobserve(e.target)
        }
      })
    },
    { threshold: 0.1, rootMargin: "0px 0px -5% 0px" }
  )

  const observeReveals = () => {
    document.querySelectorAll(".reveal:not(.is-visible)").forEach((el) => {
      const rect = el.getBoundingClientRect()
      const inView = rect.top < window.innerHeight + 80 && rect.bottom > -80
      if (inView) {
        el.classList.add("is-visible")
        return
      }
      observer.observe(el)
    })
  }

  observeReveals()
  document.addEventListener("napire-lang-updated", observeReveals)

  const revealMutationObserver = new MutationObserver((mutations) => {
    const hasAddedReveal = mutations.some((mutation) =>
      Array.from(mutation.addedNodes).some((node) =>
        node.nodeType === Node.ELEMENT_NODE
        && (node.matches?.(".reveal") || node.querySelector?.(".reveal"))
      )
    )
    if (hasAddedReveal) observeReveals()
  })
  revealMutationObserver.observe(document.body, { childList: true, subtree: true })

  const heroVideo = document.querySelector(".hero-cinematic__video")
  if (heroVideo) {
    const playHeroVideo = () => {
      heroVideo.play().catch(() => {})
    }
    playHeroVideo()
    document.addEventListener("visibilitychange", () => {
      if (!document.hidden) playHeroVideo()
    })
  }
}
